import React, { Suspense, useContext } from 'react';
import { Card, Space } from 'antd';
import { Outlet } from 'react-router-dom';
import { ProductsContext } from '../../context/ProductsContext';
import ContentLoading from './ContentLoading';
import RouteLoading from './RouteLoading';

const ContentArea = () => {
  const { productsClient, productsMissing, loading } =
    useContext(ProductsContext);

  return (
    <Space
      direction="vertical"
      size="middle"
      style={{
        padding: '1%',
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      {loading ? (
        <ContentLoading />
      ) : (
        <Card
          style={{
            width: '100%',
            maxWidth: '2000px',
            minWidth: 0,
            height: 'calc(100vh - 120px)',
            display: 'flex',
            flexDirection: 'column',
            position: 'relative',
          }}
          styles={{
            body: {
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              minHeight: 0,
              overflowY: 'auto',
              padding: '16px',
            },
          }}
        >
          <Suspense fallback={<RouteLoading />}>
            <Outlet
              context={{
                productsClient,
                productsMissing,
              }}
            />
          </Suspense>
        </Card>
      )}
    </Space>
  );
};

export default ContentArea;
